// extracted by mini-css-extract-plugin
export default {"common":"Global_common__F1ato","dark_container":"Global_dark_container__BzkAZ","light_container":"Global_light_container__-FosG"};